'use client'
import React from 'react'
import Image from 'next/image'
interface TagProps {
  label: string
  callBackFunction: (value: string) => void
}

const Tag = ({ label, callBackFunction }: TagProps) => {
  return (
    <div
      className="flex flex-row  h-[22px] bg-[#f5f5f5] text-[#5a5a5a] py-[3px] px-[5px]  items-center justify-center  min-w-fit  gap-2 cursor-pointer text-[12px] rounded"
      style={{ border: '1px solid #cecece' }}
      onClick={() => {
        callBackFunction(label)
      }}
    >
      <p> {label}</p>
      <Image
        src="/assets/Icons/closeIconOrange.svg"
        alt="close-icon"
        height={5.5}
        width={5.5}
      />
    </div>
  )
}

export default Tag
